const API_BASE = import.meta.env.VITE_API_BASE_URL || ''

export async function fetchPdf(path: string, signal: AbortSignal): Promise<Blob> {
  if (!/^\/api\/current-events\/snapshots\/[a-f0-9]{32}\/pdf$/.test(path)) throw new Error('PDF 地址无效')
  const token = localStorage.getItem('kb-token')
  const response = await fetch(`${API_BASE}${path}`, { signal, headers: token ? { Authorization: `Bearer ${token}` } : {} })
  if (!response.ok) {
    const payload = await response.json().catch(() => null)
    throw new Error(responseMessage(payload, 'PDF 加载失败'))
  }
  if (!response.headers.get('content-type')?.includes('application/pdf')) throw new Error('服务器未返回 PDF 文件')
  return response.blob()
}

export async function fetchPdfPage(path: string, signal: AbortSignal): Promise<Blob> {
  if (!/^\/api\/current-events\/snapshots\/[a-f0-9]{32}\/pages\/[1-9]\d*\.png$/.test(path)) throw new Error('PDF 页面地址无效')
  const token = localStorage.getItem('kb-token')
  const response = await fetch(`${API_BASE}${path}`, { signal, headers: token ? { Authorization: `Bearer ${token}` } : {} })
  if (!response.ok) {
    const payload = await response.json().catch(() => null)
    throw new Error(responseMessage(payload, 'PDF 页面加载失败'))
  }
  if (!response.headers.get('content-type')?.includes('image/png')) throw new Error('服务器未返回 PDF 页面图像')
  return response.blob()
}

export class ApiError extends Error {
  constructor(public status: number, message: string) { super(message) }
}

function responseMessage(payload: unknown, fallback: string): string {
  if (typeof payload === 'string' && payload.trim()) return payload
  if (payload && typeof payload === 'object') {
    const value = payload as { detail?: unknown; message?: unknown }
    if (typeof value.detail === 'string' && value.detail.trim()) return value.detail
    if (typeof value.message === 'string' && value.message.trim()) return value.message
    if (value.detail) return JSON.stringify(value.detail)
    if (value.message) return JSON.stringify(value.message)
  }
  return fallback
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const token = localStorage.getItem('kb-token')
  const headers = new Headers(options.headers)
  if (token) headers.set('Authorization', `Bearer ${token}`)
  if (options.body && !(options.body instanceof FormData)) headers.set('Content-Type', 'application/json')
  const response = await fetch(`${API_BASE}${path}`, { ...options, headers })
  const type = response.headers.get('content-type') || ''
  const payload = type.includes('json') ? await response.json() : await response.text()
  if (!response.ok) throw new ApiError(response.status, responseMessage(payload, response.statusText))
  return payload as T
}

export const unwrap = <T>(payload: { data?: T } | T): T =>
  (payload && typeof payload === 'object' && 'data' in payload ? payload.data : payload) as T
